import { render, staticRenderFns } from "./DetalleEnviarEventos.vue?vue&type=template&id=2a71b835&"
import script from "./DetalleEnviarEventos.vue?vue&type=script&lang=js&"
export * from "./DetalleEnviarEventos.vue?vue&type=script&lang=js&"
import style0 from "./DetalleEnviarEventos.vue?vue&type=style&index=0&id=2a71b835&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports